"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackInteraction = exports.getTrackInteraction = exports.getUsageTracker = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _hsSettings = require("../constants/hsSettings");

var _utils = require("../utils");

var NAMESPACE = 'rich-text';
var SCREEN = 'rich-text';
var _usageTracker = null;

var getUsageTracker = function getUsageTracker(usageTracker, appName) {
  if (_usageTracker) {
    return _usageTracker;
  }

  _usageTracker = usageTracker.clone({
    properties: {
      namespace: NAMESPACE,
      text_library: 'tinymce',
      screen: SCREEN,
      'in-app': appName || 'unkown'
    }
  });
  return _usageTracker;
};

exports.getUsageTracker = getUsageTracker;

var getEventPayload = function getEventPayload(_ref) {
  var appName = _ref.appName,
      action = _ref.action,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {} : _ref$meta;
  return {
    where_app_override: 'rich-text',
    where_screen: 'rich-text',
    what_extra_json: (0, _extends2.default)({
      action: action,
      inline: inline ? 'yes' : 'no',
      'in-app': appName || 'unknown'
    }, meta)
  };
};

var getTrackInteraction = function getTrackInteraction(_ref2) {
  var usageTracker = _ref2.usageTracker,
      appName = _ref2.appName,
      _trackInteraction = _ref2.trackInteraction,
      _ref2$inpage = _ref2.inpage,
      inpage = _ref2$inpage === void 0 ? false : _ref2$inpage;
  return function (eventName, action) {
    var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _eventName = eventName === 'Edit' ? 'tinymceEdit' : eventName;

    if (usageTracker) {
      var tracker = getUsageTracker(usageTracker, appName);
      tracker.track(_eventName, (0, _extends2.default)({
        action: action,
        inline: inpage ? 'yes' : 'no'
      }, meta));
    } else if (_trackInteraction) {
      if (inpage) {
        _trackInteraction(_eventName, (0, _extends2.default)({
          action: action,
          inline: 'yes'
        }, meta));
      } else {
        _trackInteraction('Edit', getEventPayload({
          appName: appName,
          inline: false,
          action: action,
          meta: meta
        }));
      }
    }
  };
};

exports.getTrackInteraction = getTrackInteraction;

var trackInteraction = function trackInteraction(editor, eventName, action) {
  var meta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _trackInteraction = getTrackInteraction({
    usageTracker: (0, _utils.getPluginSetting)(editor, 'usageTracker'),
    trackInteraction: (0, _utils.getPluginSetting)(editor, 'trackInteraction'),
    appName: (0, _utils.getPluginSetting)(editor, 'appName'),
    inpage: editor.settings[_hsSettings.HS_INPAGE]
  });

  _trackInteraction(eventName, action, meta);
};

exports.trackInteraction = trackInteraction;